/*jshint esversion: 6 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../css/BigLogo.css';
//import './css/Utils.css';
import bigLogo from '../images/logos/tuukan.png';//.svg';

class BigLogo extends Component {
  render() {
    return (
      <div className="big_logo_container">
      
        <div className="big_logo_div">
          <Link to = "/" >
            <img className="big_logo_img" 
                src = {bigLogo}
                alt = "Tallinna Filmikool" />
          </Link>
          <div className="logo_kiri">
            Tallinna Filmikool
          </div>
        </div>
      </div>
    );
  }
}

export default BigLogo;


// WEBPACK FOOTER //
// ./src/Templates/BigLogo.js